import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from '../../../../libraries/language';
import { ITailNumber } from '../../../../models/tail-number.model';
import style from './tail-numbers-list.module.scss';
import TailNumbersAdd from '../tail-numbers-add/tail-numbers-add.component';
import TailNumbersEdit from '../tail-numbers-edit/tail-numbers-edit.component';
import TailNumbersDelete from '../tail-numbers-delete/tail-numbers-delete.component';

type IProp = {
  data: ITailNumber[];
  loading: boolean;
};

const TailNumbersView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<ITailNumber>[] = [
    {
      title: Lang.LBL_TAIL_NUMBER,
      index: 'tailNumber',
      width: '85%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <TailNumbersEdit data={value} />
          <TailNumbersDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[1].render) {
      customColumns[1].render(true, {} as ITailNumber, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_TAIL_NUMBERS} />
        <TailNumbersAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default TailNumbersView;
